<sb-dialog-header>
  <h1 sb-dialog-title>
    {{ 'Edit Template Name' | translate }}
  </h1>
</sb-dialog-header>

<sb-dialog-content>
  <form sb-dialog-form [formGroup]="form" (ngSubmit)="submit()">
    <sb-form-field [errorWhen]="['touched']" [control]="form.controls.title" [label]="'Name' | translate">
      <input sbInput formControlName="title" />
    </sb-form-field>

    @if (features.TMP_GUARDIAN_SIGNATURE | featureFlag) {
      @if (features.TMP_GUARDIAN_SIGNATURE_COUNT | featureFlag) {
        <sb-form-field
          [control]="form.controls.guardianSignatureCount"
          [label]="'Number of guardians' | translate"
          [tooltip]="
            'You can only raise the count if the document already contains the matching guardian fields.' | translate
          "
        >
          <sb-select [items]="guardianSignatureCountItems" formControlName="guardianSignatureCount"></sb-select>
        </sb-form-field>
      } @else {
        <sb-checkbox formControlName="requiresGuardianSignature" [truncateLabel]="false">
          {{ 'Requires guardian signature' | translate }}
        </sb-checkbox>
      }
    }
  </form>
</sb-dialog-content>

<sb-dialog-footer>
  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button [color]="'secondary'" sb-dialog-close>{{ 'Cancel' | translate }}</button>
    <button sb-button [color]="'primary'" [sbLadda]="loading" (click)="submit()">
      {{ 'Save' | translate }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
